import { useForm } from 'react-hook-form';

export const defaultHookFormMode = {
  mode: 'onChange',
  reValidateMode: 'onChange',
} as const;

/**
 * Custom hook for creating a form with default validation modes.
 * Sets 'onChange' as the default mode for instant feedback but allows overrides.
 *
 * Note: Consider adding a custom biome lint rule to enforce using useCustomForm instead of useForm once NIM-20339 is done.
 *
 * @param props - Form configuration options, with optional mode overrides.
 * @returns Form methods and state from useForm.
 */
export const useCustomForm: typeof useForm = (props) =>
  useForm({
    ...defaultHookFormMode,
    ...props, // override defaults if desired
  });
